import { Grid } from "antd";

const { useBreakpoint } = Grid;

export  function useIsMobile() {
  const screens = useBreakpoint();
  return !screens.md; // أقل من md = موبايل
}

export  function useIsMobileAndTab() {
  const screens = useBreakpoint();
  return !screens.lg; // أقل من 992px = جوال + تابليت صغير
}